import React from "react";
import styled from "styled-components";
import Image from "next/image";
import InfoIcon from "@public/images/icons/info-icon.svg";
import DOMPurify from "isomorphic-dompurify";

const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  width: fit-content;
  max-width: 500px;
  border-radius: 12px;
  border: 1px solid #efe9fb;
  background: #f9f6ff;
  margin-bottom: 2rem;
`;

const IconContainer = styled.div`
  width: 40px;
  height: 40px;
  margin-right: 10px;
  position: relative;
`;

const MessageText = styled.div`
  color: #36354c;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  strong {
    font-weight: 600;
  }
`;

const IdvInfoMessage = ({ message }) => {
  return (
    <MessageContainer>
      <IconContainer>
        <Image
          src={InfoIcon}
          alt="Info-icon"
          layout="fill"
          objectFit="contain"
        />
      </IconContainer>
      <MessageText>
        <div
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message) }}
        />
      </MessageText>
    </MessageContainer>
  );
};

export default IdvInfoMessage;
